import { render } from "./SuperadminFullTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=template&id=5132acb3"
import script from "./SuperadminFullTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=script&lang=js"
export * from "./SuperadminFullTreatmentTemplateDatatableFormDiagnoses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__